import { nsTerminal } from '@/app/i18n/namespaces';

const POS_TERMINAL_STATUS = {
    TEMPORARILY_ALLOWED: { name: 'TEMPORARILY_ALLOWED', entity: 'status.TEMPORARILY_ALLOWED', namespace: nsTerminal, variant: 'orange' },
    ALLOWED: { name: 'ALLOWED', entity: 'status.ALLOWED', namespace: nsTerminal, variant: 'green' },
    BLOCKED: { name: 'BLOCKED', entity: 'status.BLOCKED', namespace: nsTerminal, variant: 'red' }
};

export default POS_TERMINAL_STATUS;